import { useParams } from "react-router";
import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// cmp
import Svg from "../svg";
import SupportUserInvite from "./support-user-invite";
// services
import Gupport from "../../services/gupport";
// types
import type { UserId } from "../../types/user";

type RouteParams = {
	userId: UserId;
};

const SupportUserRightIcon = () => {
	const theme = useTheme();

	const params = useParams<RouteParams>();

	const handleOpenNewWindow = () => {
		if (params.userId) {
			window.open(
				`support_user.html#/support/users/${encodeURIComponent(params.userId)}`,
				"_blank"
			);
		}
	};

	return (
		<>
			{Gupport.addGlogin && <SupportUserInvite />}
			<IconButton disabled={!params.userId} onClick={handleOpenNewWindow}>
				<Svg src="navigation/openNewWindow.svg" color={params.userId ? theme.vars.palette.primary.main : theme.vars.palette.text.disabled} />
			</IconButton>
		</>
	);
};

export default SupportUserRightIcon;
